export const TIMEOUT_LONG = 20000;
export const TIMEOUT_SHORT = 10000;
// export const TIMEOUT_SHORT = 10000;